import { render, staticRenderFns } from "./Flowtable.vue?vue&type=template&id=ac20b542&scoped=true"
import script from "./Flowtable.vue?vue&type=script&lang=js"
export * from "./Flowtable.vue?vue&type=script&lang=js"
import style0 from "./Flowtable.vue?vue&type=style&index=0&id=ac20b542&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac20b542",
  null
  
)

export default component.exports